import { createAsyncThunk } from '@reduxjs/toolkit';

import { JsonQuery, type TJsonQuery } from '@/packages/JsonQuery';

import { MOSCOW_ID } from '@/microfrontends/filters/shared/constants/regions';
import { prepareCities } from '@/microfrontends/filters/shared/mappers/prepareCities';
import { fetchGetCities } from '@/microfrontends/filters/shared/services/fetchCities';
import { type ILocation, type TLocation } from '@/microfrontends/filters/shared/types/location';
import { locationHasNeighbors } from '@/microfrontends/filters/shared/utils/locationHasNeighbors';
import { tempNormalizeLocation } from '@/microfrontends/filters/shared/utils/tempNormalizeLocation';

import { type TThunkApi } from '../../types';

import { updateMeta } from './updateMeta';

interface ISelectRegionResult {
  region: TLocation;
  cities: ILocation[];
  jsonQuery: TJsonQuery;
}

export const selectRegion = createAsyncThunk<ISelectRegionResult, TLocation, TThunkApi>(
  'locationPopup/selectRegion',
  async (region, thunkApi) => {
    const { extra, getState, dispatch } = thunkApi;
    const state = getState();
    const subdomain = extra.custom.subdomain;

    let cities: ILocation[] = [];
    const normalizedRegion = tempNormalizeLocation(region);
    const nextJsonQuery = new JsonQuery(state.locationPopup.jsonQuery);

    if (region !== 'moscow_mo' && region !== 'spb_lo') {
      const citiesResponse = await fetchGetCities(extra, { regionId: region.id }, { subdomain });
      cities = citiesResponse.map(prepareCities).unwrapOr([]);
    }

    // сбрасываем фильтр domrf, если в выбранном регионе нет Москвы
    if (!normalizedRegion.some(({ id }) => id === MOSCOW_ID)) {
      nextJsonQuery.setIsByDomRf(null);
    }

    // перенёс костыль для попапа смены региона, иначе мета запрашивается с тегом всегда
    if (!locationHasNeighbors(region)) {
      nextJsonQuery.setWithNeighbors(null);
    }

    nextJsonQuery.setLocations({ next: normalizedRegion, prev: tempNormalizeLocation(state.location.data) });

    const nextJsonQuerySerialized = nextJsonQuery.toJSON();

    // специально не блокируемся об получение мета
    dispatch(updateMeta(nextJsonQuerySerialized));

    return {
      region,
      cities,
      jsonQuery: nextJsonQuerySerialized,
    };
  },
);
